/**
 * 포커 게임 실행 트리거
 */
export function runGame() {
  $(document).trigger('app:runGame')
}

/**
 * poker.js 의 유저 정보 재로딩 트리거
 */
export function refresh() {
  $(document).trigger('app:refresh')
}
